module.exports = __webpack_public_path__ + "img/people.822e8d17.png";